module.exports = __webpack_public_path__ + "5b654e1a7246e45c6577b66c7b935620.svg";